<template>
    <div :id="info.id" class="order_box_item" @click="gotoDetail(info.goods_type,info.id,info.order_num)">
        <div class="l1">
            <span class="game_name">{{ info.app_name }}</span>
            <div v-if="otype == 2">
                <div>
                    <span class="status status0" v-if="info.deliver_status == 0">待发货</span>
                    <span class="status status1" v-if="info.deliver_status == 1">交易完成</span>
                    <span class="status status2" v-if="info.deliver_status == 2||info.deliver_status == 3">已取消</span>
                    <span class="status status2" v-if="info.deliver_status == 10">发货失败</span>
                </div>
            </div>
            <div v-else-if="otype == 1">
                <div v-if="info.status == 1">
                    <span class="status status0" v-if="info.deliver_status == 0">待发货</span>
                    <span class="status status1" v-if="info.deliver_status == 1">交易完成</span>
                    <span class="status status2" v-if="info.deliver_status == 2||info.deliver_status == 3">已取消</span>
                    <span class="status status2" v-if="info.deliver_status == 10">发货失败</span>
                </div>
                <div v-else-if="info.status == 0">
                    <span class="status status0">待付款</span>
                </div>
                <div v-else-if="info.status == 3">
                    <span class="status status2">订单取消</span>
                </div>
                <div v-else-if="info.status == 4">
                    <span class="status status2">订单过期</span>
                </div>
                <div v-else-if="info.status == 5">
                    <span class="status status2">发货失败退还</span>
                </div>
            </div>
        </div>
        <div class="l2">
            <van-image class="icon first_pic" :src="info.first_pic" v-if="info.first_pic" />
            <van-image class="icon" :src="info.icon" v-else/>
            <div class="info">
                <p class="type">交易类型：{{info.goods_type_name}}</p>
                <p class="goods_name">
                    <span class="name" v-if="info.goods_type == 1">{{ info.goods_name }}</span>
                    <span class="name" v-else>角色名：{{ info.role_name }}</span>
                    <span class="num" v-if="info.goods_type == 1">X{{ info.num }}</span>
                </p>
                <p class="server_name">{{ info.server_name }}</p>
            </div>
        </div>
        <div class="price">
            <div class="left" v-if="info.status == 0 && otype == 1">
                待付款：
                <van-count-down :time="countdown(info.ctime)" @finish="finish">
                    <template #default="timeData">
                        <span
                            class="block">{{ (timeData.days*24*60 + timeData.hours*60 + timeData.minutes) < 10? '0'+ (timeData.days*24*60 + timeData.hours*60 +timeData.minutes): (timeData.days*24*60 + timeData.hours*60 + timeData.minutes) }}</span>
                        <span class="colon">:</span>
                        <span class="block">{{timeData.seconds < 10 ? '0'+ timeData.seconds : timeData.seconds }}</span>
                    </template>
                </van-count-down>
            </div>
            <div class="left" v-else></div>
            <div class="right">
                售价：
                <span class="yen">&yen;</span>&nbsp;<i>{{ info.price }}</i>
            </div>
        </div>
        <div class="wait_pay" v-if="info.status == 0&&otype == 1">
            <van-button round plain color="#9e9e9e" @click.stop="cancelOrder(info.order_num,info.id)">取消订单</van-button>
            <van-button round plain color="#EF4D3D">去支付</van-button>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['info', 'otype', 'index'],
        data() {
            return {
                currentServeTime: '',
                //倒计时  15分钟
                interval_time: 900000,
            }
        },
        computed: {
            differTime() {
                return this.$store.state.differTime;
            },
        },
        created() {
            this.getTime()
        },
        mounted() {},
        methods: {
            finish() {
                this.$emit('finishFunc', this.index)
            },
            countdown(createtime) {
                let endtime = new Date(createtime.replace(/-/g, '/')).getTime() + this.interval_time;
                let now = new Date(this.currentServeTime).getTime();
                let left = endtime - now;
                return left;
            },
            getTime() {
                var now = new Date();
                this.currentServeTime = new Date(now.valueOf() - this.differTime);
            },
            gotoDetail(type, id, order_num) {
                if (type == 1) {
                    this.$router.push({
                        name: "goods.detail",
                        query: {
                            order_num,
                            type: this.otype == 1 ? "buy" : "sell",
                        },
                    });
                } else {
                    this.$router.push({
                        name: 'user.order',
                        query: {
                            order_num,
                            type: this.otype == 1 ? "buy" : "sell",
                        }
                    })
                }
            },
            //取消订单
            cancelOrder(order_num, id) {
                this.$RModal.cancelorder({
                    noheader: true,
                    onSuccess: () => {
                        this.$Ajax('order/cancel', {
                            order_num
                        }, 'post').then(rs => {
                            if (rs.code == 200) {
                                const hid = document.getElementById(id)
                                hid.style.display = 'none'
                            }
                        })
                    }
                })
            }
        },
        watch: {},
    }
</script>

<style lang="less" scoped>
    .order_box_item {
        background-color: #fff;
        border-radius: 1rem;
        padding: 1rem;
        margin-bottom: 1.6rem;
        cursor: pointer;

        .l1 {
            display: flex;
            justify-content: space-between;
            margin-bottom: 1rem;

            .game_name {
                font-size: 1.4rem;
                color: #000;
                font-weight: 700;
            }

            .status {
                font-size: 1.4rem;

                &.status0 {
                    color: #ff0000;
                }

                &.status1 {
                    color: #EF4D3D;
                }

                &.status2 {
                    color: #9999;
                }
            }
        }

        .l2 {
            display: flex;
            align-items: flex-start;
            margin-bottom: 1rem;

            .icon {
                width: 9rem;
                height: 9rem;
                border-radius: 1.6rem;
                overflow: hidden;
                margin-right: 1rem;
            }

            .info {
                flex: 1;
                overflow: hidden;

                .type {
                    font-size: 1.4rem;
                    color: #000;
                    font-weight: 700;
                    margin-bottom: .8rem;
                }

                .goods_name {
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-between;
                    margin-bottom: .8rem;
                    font-size: 1.4rem;

                    .name {
                        flex: 1;
                        word-break: break-all;
                    }

                    .num {
                        margin-left: .8rem;
                    }
                }

                .server_name {
                    color: #999;
                    font-size: 1.2rem;
                }
            }
        }

        .price {
            display: flex;
            justify-content: space-between;
            font-size: 1.6rem;
            color: #000;

            .left {
                display: flex;
                align-items: center;
                font-size: 1.2rem;
                color: #EF4D3D;

                .colon {
                    margin: 0 0.25rem;
                    color: #EF4D3D;
                }

                .block {
                    display: inline-block;
                    line-height: 2rem;
                    height: 2rem;
                    padding: 0 0.5rem;
                    background-color: #EF4D3D;
                    font-size: 1.2rem;
                    color: #fff;
                    border-radius: .2rem;
                }
            }

            .yen {
                font-size: 1.2rem;
            }

            i {
                font-size: 1.8rem;
                font-weight: 700;
            }
        }
    }

    .wait_pay {
        margin-top: 1.2rem;
        padding: 1.4rem 0 .8rem;
        border-top: 1px solid #f2f2f2;
        display: flex;
        justify-content: flex-end;

        .van-button {
            padding: 0;
            width: 8.4rem;
            height: 3.4rem;
            margin-left: 1rem;
            font-size: 1.4rem;
        }
    }
</style>